import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { router, routes } from "./app/routes";
import PageLayout from "./pages/PageLayout";
import UserService from "./services/UserService";

export default function Root() {
  const location = useLocation();
  const [isSignedIn, setIsSignedIn] = useState(false);

  useEffect(() => {
    const loginOk = UserService.isSignedIn();
    if (!loginOk) {
      router.navigate(`${routes.login}?returnUrl=${location.pathname}`);
      setIsSignedIn(false);
    }

    setIsSignedIn(loginOk);

    return () => {};
  }, [location.pathname]);

  if (!isSignedIn) {
    return <Outlet />;
  }

  return <PageLayout></PageLayout>;
}

